// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"980":"91f539c9","984":"240f09fa"}[chunkId] + ".chunk.css";
};